module.exports = __webpack_public_path__ + "img/Vector.ed2ab9f8.svg";